import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import { EditorView } from 'prosemirror-view';
import { createSlice } from '../context';
import { createTimer } from '../timing';
import { editorStateCtx, EditorStateReady } from './editor-state';
import { nodeViewCtx, NodeViewReady } from './node-view';
export const editorViewCtx = createSlice({}, 'editorView');
export const editorViewOptionsCtx = createSlice({}, 'editorViewOptions');
export const rootCtx = createSlice(document.body, 'root');
export const editorViewTimerCtx = createSlice([], 'editorViewTimer');
export const EditorViewReady = createTimer('EditorViewReady');
const createViewContainer = (root) => {
    const container = document.createElement('div');
    container.className = 'milkdown';
    root.appendChild(container);
    return container;
};
const prepareViewDom = (dom) => {
    dom.classList.add('editor');
    dom.setAttribute('role', 'textbox');
};
export const editorView = (pre) => {
    pre.inject(rootCtx, document.body)
        .inject(editorViewCtx)
        .inject(editorViewOptionsCtx)
        .inject(editorViewTimerCtx, [EditorStateReady, NodeViewReady])
        .record(EditorViewReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(editorViewTimerCtx);
        const state = ctx.get(editorStateCtx);
        const options = ctx.get(editorViewOptionsCtx);
        const nodeView = ctx.get(nodeViewCtx);
        const root = ctx.get(rootCtx);
        const container = root ? createViewContainer(root) : undefined;
        const view = new EditorView(container, Object.assign({ state, nodeViews: nodeView }, options));
        prepareViewDom(view.dom);
        ctx.set(editorViewCtx, view);
        ctx.done(EditorViewReady);
    });
};
//# sourceMappingURL=editor-view.js.map